(() => {
  if (customElements.get('marastoni-gallery-progress')) return;

  class MarastoniGalleryProgress extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.carousel = document.getElementById(this.getAttribute('aria-controls')) || this.closest('product-gallery')?.querySelector('media-carousel');
      if (!this.carousel) return;

      this.previousButton = this.querySelector('[data-gallery-previous]');
      this.nextButton = this.querySelector('[data-gallery-next]');
      this.progress = this.querySelector('[data-gallery-progress]');
      this.status = this.querySelector('[data-gallery-status]');

      this.previousButton?.addEventListener('click', () => this.carousel.previous?.(), { signal: this.abortController.signal });
      this.nextButton?.addEventListener('click', () => this.carousel.next?.(), { signal: this.abortController.signal });

      ['carousel:select', 'carousel:change', 'carousel:settle'].forEach(eventName => {
        this.carousel.addEventListener(eventName, () => this.update(), { signal: this.abortController.signal });
      });

      this.carousel.addEventListener('carousel:filter', () => requestAnimationFrame(() => this.update()), { signal: this.abortController.signal });
      requestAnimationFrame(() => this.update());
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    update() {
      if (!this.carousel) return;
      const visibleItems = this.carousel.visibleItems || Array.from(this.carousel.children).filter(item => !item.hidden);
      const total = visibleItems.length;
      let index = visibleItems.indexOf(this.carousel.selectedSlide);
      if (index < 0) index = 0;

      const current = total ? index + 1 : 0;
      const percent = total ? (current / total) * 100 : 0;
      this.style.setProperty('--marastoni-gallery-progress', `${percent}%`);
      if (this.progress) this.progress.style.width = `${percent}%`;
      if (this.status) this.status.textContent = `Billede ${current} af ${total}`;
      if (this.previousButton) this.previousButton.disabled = total <= 1 || index <= 0;
      if (this.nextButton) this.nextButton.disabled = total <= 1 || index >= total - 1;
      this.hidden = total <= 1;
    }
  }

  customElements.define('marastoni-gallery-progress', MarastoniGalleryProgress);
})();
